import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable, NEVER } from 'rxjs';
import { Organization } from '../../../models/organization';
import { OrganizationsService } from '../../organizations.service';
import { tap, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { UnauthorizedError } from '../../../util/http.service';
import { MessageEventService } from '../../../util/message-event.service';
import { ActionConfirmer } from 'src/app/util/confirmation';
import { ActionConfirmationService } from 'src/app/util/confirmation/confirmation.service';

@Component({
  selector: 'app-webhook-signing-key',
  templateUrl: './webhook-signing-key.component.html',
  styleUrls: ['./webhook-signing-key.component.scss'],
})
export class WebhookSigningKeyComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  item$: Observable<Organization>;

  unauthorized = false;
  loading = false;

  inputState = {
    visible: false,
    type: 'password',
    icon: 'visibility',
    label: 'Show',
  };

  private actionConfirmer: ActionConfirmer;

  constructor(
    private orgService: OrganizationsService,
    dialog: MatDialog,
    private messageService: MessageEventService
  ) {
    this.actionConfirmer = new ActionConfirmationService(dialog);
  }

  confirmClearKey() {
    this.unauthorized = false;
    this.actionConfirmer.confirmAction(
      'Are you sure you want to clear the webhook signing key? Future webhooks will NOT be signed.',
      () => {
        this.loading = true;
        this.subscription.add(
          this.orgService.clearWebhookSigningKey().subscribe(() => {
            this.item$ = this.orgService.getEntity().pipe(
              tap(() => {
                this.loading = false;
              })
            );
          })
        );
      }
    );
  }

  confirmRegenerateKey() {
    this.unauthorized = false;
    this.actionConfirmer.confirmAction(
      'Are you sure you want to regenerate the webhook signing key?',
      () => {
        this.loading = true;
        this.item$ = this.orgService.regenerateWebhookSigningKey().pipe(
          tap((org) => {
            if (org) {
              this.messageService.pushEvent({
                message: 'Webhook signing key regenerated',
                status: 'success',
              });
            }
            this.loading = false;
          }),
          catchError((error: Error) => {
            if (error instanceof UnauthorizedError) {
              this.unauthorized = true;
            }
            return NEVER;
          })
        );
      }
    );
  }

  toggleKeyVisibility() {
    if (this.inputState.visible) {
      this.inputState.label = 'Show';
      this.inputState.icon = 'visibility';
      this.inputState.type = 'password';
      this.inputState.visible = false;
    } else {
      this.inputState.label = 'Hide';
      this.inputState.icon = 'visibility_off';
      this.inputState.type = 'text';
      this.inputState.visible = true;
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.item$ = this.orgService.getEntity().pipe(
      tap(() => {
        this.loading = false;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
